import * as actionTypes from "../actions/actionTypes";

export default function notifications(state = {}, action) {
  const nextState = Object.assign({}, state);

  if (action.type === actionTypes.NOTIFICATION_SHOW) {
    nextState[action.id] = {
      message: action.message,
      level: action.level,
      link: action.link,
    };
  } else if (action.type === actionTypes.NOTIFICATION_HIDE) {
    delete nextState[action.id];
  } else {
    return state;
  }

  return nextState;
}
